module.exports = __webpack_public_path__ + "img/creative-eu.b2a3553c.png";